import { render, staticRenderFns } from "./ModalBasketDel.vue?vue&type=template&id=8a5e33a2&"
import script from "./ModalBasketDel.vue?vue&type=script&lang=js&"
export * from "./ModalBasketDel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports